import PlayIcon from './PlayIcon';

export default PlayIcon;
